var jade = require("C:\\Documents and Settings\\kopperts\\My Documents\\repos\\webpack-development\\node_modules\\example-app\\node_modules\\jade-loader\\node_modules\\jade\\lib\\runtime");

module.exports = function anonymous(locals, attrs, escape, rethrow, merge) {
attrs = attrs || jade.attrs; escape = escape || jade.escape; rethrow = rethrow || jade.rethrow; merge = merge || jade.merge;
var buf = [];
var self = locals || {};
var interp;
buf.push('<div class="progress progress-striped active"><div style="width: 100%" class="bar"></div></div>');return buf.join("");
}